export const RegionData = [
    { value: "현재 지도", name: "현재 지도", },
    { value: "서울 종로구", name: "서울 종로구", lat: 37.5729, lng: 126.9794, level: 5 },
    { value: "서울 중구", name: "서울 중구", lat: 37.5641, lng: 126.9970, level: 6 },
    { value: "서울 용산구", name: "서울 용산구", lat: 37.5311, lng: 126.9814, level: 6 },
    { value: "서울 성동구", name: "서울 성동구", lat: 37.5509, lng: 127.0407, level: 6 },
    { value: "서울 광진구", name: "서울 광진구", lat: 37.5388, lng: 127.0827, level: 6 },
    { value: "서울 동대문구", name: "서웅 동대문구", lat: 37.5744, lng: 127.0395, level: 6 },
    { value: "서울 중랑구", name: "서울 중랑구", lat: 37.6065, lng: 127.0927, level: 6 },
    { value: "서울 성북구", name: "서울 성북구", lat: 37.6109, lng: 127.0273, level: 6 },
    { value: "서울 강북구", name: "서울 강북구", lat: 37.6396, lng: 127.0257, level: 6 },
    { value: "서울 도봉구", name: "서울 도봉구", lat: 37.6688, lng: 127.0471, level: 6 },
    { value: "서울 노원구", name: "서울 노원구", lat: 37.6550, lng: 127.0778, level: 6 },
    { value: "서울 은평구", name: "서울 은평구", lat: 37.6027, lng: 126.9288, level: 6 },
    { value: "서울 서대문구", name: "서울 서대문구", lat: 37.5794, lng: 126.9368, level: 6 },
    { value: "서울 마포구", name: "서울 마포구", lat: 37.5662, lng: 126.9018, level: 6 },
    { value: "서울 양천구", name: "서울 양천구", lat: 37.5271, lng: 126.8561, level: 6 },
    { value: "서울 강서구", name: "서울 강서구", lat: 37.5509, lng: 126.8497, level: 6 },
    { value: "서울 구로구", name: "서울 구로구", lat: 37.4954, lng: 126.8581, level: 6 },
    { value: "서울 금천구", name: "서울 금천구", lat: 37.4574, lng: 126.8956, level: 6 },
    { value: "서울 영등포구", name: "서울 영등포구", lat: 37.5265, lng: 126.8962, level: 6 },
    { value: "서울 동작구", name: "서울 동작구", lat: 37.4979, lng: 126.9828, level: 6 },
    { value: "서울 관악구", name: "서울 관악구", lat: 37.4654, lng: 126.9436, level: 6 },
    { value: "서울 서초구", name: "서울 서초구", lat: 37.4761, lng: 127.0376, level: 6 },
    { value: "서울 강남구", name: "서울 강남구", lat: 37.5184, lng: 127.0473, level: 6 },
    { value: "서울 송파구", name: "서울 송파구", lat: 37.5048, lng: 127.1147, level: 6 },
    { value: "서울 강동구", name: "서울 강동구", lat: 37.5499, lng: 127.1465, level: 6 },

    { value: "경기도", name: "경기도", lat: 37.65590833, lng: 126.7770556, level: 8 },
    { value: "대구", name: "대구", lat: 35.86952722, lng: 128.6061745, level: 9 },
    { value: "부산", name: "부산", lat: 35.10321667, lng: 129.0345083, level: 9 },
    { value: "제주도", name: "제주도", lat: 33.374278, lng: 126.537814, level: 10 },
    { value: "인천", name: "인천", lat: 37.47384843, lng: 126.6217617, level: 8 },
];